document.addEventListener('DOMContentLoaded', function () {

    // horizontal-line
    const horizontalLines = document.querySelectorAll('.horizontal-line');
    if (horizontalLines) {
        function handleAppend() {
            const windowWidth = window.innerWidth;
            horizontalLines.forEach((horizontalLine) => {
                const bgImg = horizontalLine.querySelector('.bg-img');
                const divider = horizontalLine.querySelector('.divider');
                const heroRight = horizontalLine.querySelector('.right-block'); // The element to append

                // Check if window width is greater than 767
                if (windowWidth > 767) {
                    // Only append if it's not already appended to the bg-img
                    if (!bgImg.contains(divider)) {
                        // Create the divider element
                        const divider = document.createElement('div');
                        divider.classList.add('divider');

                        // Create the left and right spans
                        const leftSpan = document.createElement('span');
                        leftSpan.classList.add('left');
                        const rightSpan = document.createElement('span');
                        rightSpan.classList.add('right');

                        // Append spans to the divider
                        divider.appendChild(leftSpan);
                        divider.appendChild(rightSpan);
                        bgImg.appendChild(divider);
                    }
                } else {
                    // If window width is less than 767, remove the element from bg-img if it exists
                    var appendedContainer = bgImg.querySelector('.container');
                    var appendedDivider = bgImg.querySelector('.divider');
                    if (appendedContainer) {
                        bgImg.removeChild(appendedContainer);
                    }
                    if (appendedDivider) {
                        bgImg.removeChild(appendedDivider);
                    }
                }
            });
        }

        // Call the function on load and resize
        window.addEventListener('load', handleAppend);
        window.addEventListener('resize', handleAppend);


        // Set text alignment
        function setText() {
            const windowWidth = window.innerWidth;
            horizontalLines.forEach((horizontalLine) => {
                const bgImgContainer = horizontalLine.querySelector('.bg-img .container');
                const bgDivider = horizontalLine.querySelector('.divider');

                if (bgDivider) {
                    const container = horizontalLine.querySelector('.container');
                    const containerRightSpace = container.getBoundingClientRect().right;
                    const heroBanner = horizontalLine.classList.contains('hero-banner');
                    const bannerSecond = horizontalLine.classList.contains('banner-second-level');
                    const cta = horizontalLine.classList.contains('cta');
                    const leftLine = horizontalLine.querySelector('.divider span.left');
                    const rightLine = horizontalLine.querySelector('.divider span.right');
                    let leftBlock;
                    let leftSpace;
                    let elmWidth;
                    if (heroBanner || cta) {
                        if (windowWidth > 1399) {
                            leftBlock = horizontalLine.querySelector('.period');
                        } else {
                            leftBlock = horizontalLine.querySelector('.left-block');
                        }
                        leftSpace = leftBlock.getBoundingClientRect().left;
                        elmWidth = leftBlock.getBoundingClientRect().width;
                        if (windowWidth > 1399) {
                            leftLine.style.left = leftSpace + elmWidth + 120 + 'px';
                        } else {
                            leftLine.style.left = leftSpace + elmWidth + 'px';
                        }
                    }
                    if (bannerSecond) {
                        leftBlock = horizontalLine.querySelector('.left-block');
                        leftSpace = leftBlock.getBoundingClientRect().left;
                        elmWidth = leftBlock.getBoundingClientRect().width;
                        leftLine.style.left = leftSpace + elmWidth + 'px';
                    }
                    rightLine.style.right = containerRightSpace + 'px';
                }
            });
        }

        // Run the function on window load and resize
        window.addEventListener('load', setText);
        window.addEventListener('resize', setText);

    }
});

